<template>
  <div class="continer">
    <div class="header">
      <!-- 返回 -->
      <div class="back" @click="goBack()">
        <img src="@/assets/images/daily_task/close.png" alt="" srcset="" />
      </div>
      <!-- 标题 -->
      <div class="title">历史榜单</div>
    </div>
    <div class="main">
      <div class="tab">
        <div
          class="item"
          :class="{ active: rankingType == 'daily' }"
          @click="changeRankingType('daily')"
        >
          日榜
        </div>
        <div
          class="item"
          :class="{ active: rankingType == 'weekly' }"
          @click="changeRankingType('weekly')"
        >
          周榜
        </div>
      </div>
      <div class="content">
        <div class="top">
          <!-- 上一个 -->
          <div class="before_day" @click="changeBefore()">
            {{ awardGiveTime.btnTxt }}
          </div>
          <div class="day_txt">{{ awardGiveTime.time }}</div>
        </div>
        <div class="table">
          <div class="row head">
            <div class="item">排名</div>
            <div class="item">用户</div>
            <div class="item">累计赚取</div>
            <div class="item">奖励</div>
          </div>
          <div class="row" v-for="(item, index) in pageData.list" :key="index">
            <div class="item">{{ item.level }}</div>
            <div class="item name">{{ item.nickname }}</div>
            <div class="item">{{ item.integral }}</div>
            <div class="item">{{ item.reward_money }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- loading -->
    <loading :isLoad="isLoading"></loading>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Empty, Popup } from 'vant'
import Loading from '@/components/Loading'

Vue.use(Toast)
  .use(Empty)
  .use(Popup)

export default {
  name: 'Rule',
  components: {
    Loading,
  },
  data() {
    return {
      // 用户信息
      userId: '',
      deviceId: '',
      appVersion: '',
      // 当前活动id
      currentRankId: '',
      // 加载状态
      isLoading: false,
      // 榜单类型
      rankingType: 'daily',
      pageData: {
        up_activity: {
          activity_id: '',
          begin_date: '',
        },
        list: [],
      },
    }
  },
  computed: {
    // 发奖时间
    awardGiveTime() {
      if (this.rankingType == 'daily') {
        if (!this.pageData.up_activity.activity_id) {
          return {
            btnTxt: '上一天',
            time: '-',
          }
        } else {
          return {
            btnTxt: '上一天',
            time: `2025.${this.pageData.current_activity.begin_date}`,
          }
        }
      } else {
        return {
          btnTxt: '上一周',
          time: `2025.${this.pageData.up_activity.begin_date}`,
        }
      }
    },
  },
  created() {
    this.userId = this.getCookie('userid')
    this.deviceId = this.getCookie('device_id')
    this.appVersion = this.getCookie('app_version')
    if (!this.userId) {
      this.userId = this.$route.query.user_id
      this.deviceId = this.$route.query.device_id
      this.appVersion = this.$route.query.app_version
    }
    this.getPageData()
  },
  methods: {
    getCookie: function(name) {
      var strcookie = document.cookie //获取cookie字符串
      var arrcookie = strcookie.split('; ') //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=')
        if (arr[0] == name) {
          return arr[1]
        }
      }
      return ''
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 切换榜单类型
    changeRankingType(type) {
      if (!type || this.rankingType == type) {
        return
      }
      this.currentRankId = ''
      this.rankingType = type
      this.getPageData()
    },
    // 获取页面数据
    getPageData() {
      const params = {
        userid: this.userId,
        device_id: this.deviceId,
        app_version: this.appVersion,
        activity_type: 1, // 1:周榜 3:日榜
      }
      this.isLoading = true
      // 日榜|周榜 数据
      if (this.rankingType == 'daily') {
        params.activity_type = 3
      }
      // 传入id
      if (this.currentRankId != '') {
        params.activity_id = this.currentRankId
      }
      this.$http
        .get('/api/user_web/show_activity_by_type', { params: params })
        .then((res) => {
          // 设置数据
          this.setItem(res.data.list)
          this.isLoading = false
        })
    },
    setItem(config) {
      Object.keys(config).forEach((key) => {
        switch (true) {
          // 榜单数据配置
          case config[key].itemCategory == 'item_data_day':
          case config[key].itemCategory == 'item_data_week':
            // 榜单用户列表
            this.pageData.list = config[key].item_list
            break
          // 榜单相关配置
          case config[key].itemCategory == 'item_stage':
            // 上一期
            if (config[key].item_stage.hasOwnProperty('up_activity')) {
              this.pageData.up_activity = config[key].item_stage.up_activity
            } else {
              this.pageData.up_activity = { activity_id: '' }
            }
            this.pageData.current_activity = config[key].item_stage.current_activity
            break
        }
      })
    },
    // 切换上一期
    changeBefore() {
      if (!this.pageData.up_activity.activity_id) {
        Toast({
          message: '没有上一期了哦~',
          position: 'bottom',
        })
        return
      }
      this.currentRankId = this.pageData.up_activity.activity_id
      // 获取数据
      this.getPageData()
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
  position: relative;
  min-height: 100vh;
}

.header {
  display: flex;
  align-items: center;
  height: 0.44rem;
  padding-top: 0.3rem;
  position: relative;

  .back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.44rem;
    height: 0.33rem;
    position: absolute;
    // top: 0.3rem;
    left: 0;
    z-index: 999;

    img {
      width: 0.14rem;
    }
  }

  .title {
    flex: 1;
    display: flex;
    justify-content: center;
    font-size: 0.16rem;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.18rem;
    font-weight: 500;
  }
}

.main {
  .tab {
    width: 2.64rem;
    height: 0.38rem;
    line-height: 0.38rem;
    padding: 0.02rem 0.04rem;
    margin: 0.16rem auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9f9f9;
    border-radius: 0.38rem;
    font-size: 0.16rem;
    color: #333333;
    font-weight: 500;

    .item {
      flex: 1;
      height: 100%;
      text-align: center;
      border-radius: inherit;
    }

    .item.active {
      background: #ffffff;
    }
  }

  .content {
    .top {
      display: grid;
      grid-template-columns: 1rem 1.6rem;
      margin-bottom: 0.1rem;
      justify-items: center;

      .before_day,
      .day_txt {
        font-size: 0.12rem;
        color: #333333;
      }

      .day_txt {
        font-weight: 600;
      }
    }

    .table {
      .row {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: center;
        height: 0.36rem;

        .item {
          font-size: 0.12rem;
          color: #333333;
          text-align: center;
        }

        .item.name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        // 奇数行
        &:nth-child(odd) {
          background: #fff7f5;
        }
      }

      .row.head {
        height: 0.3rem;
        background: #ff5032;

        .item {
          color: #ffffff;
        }
      }
    }
  }
}
</style>
